import { useEffect } from "react";
import AuthLayout from "../auth/layout";

const TrialExpiredPage = () => {
  useEffect(() => {
    document.title = "Account Expired - RueBaRue";
  }, []);

  return (
    <AuthLayout>
      <div className="page-box sign-in auth">
        <div className="uk-form-stacked">
          <h2>Account Expired</h2>
          <div className="uk-margin">
            Your account has expired; to reactivate your account or subscription, email{" "}
            <a href="mailto:support@ruebarue.com">support@ruebarue.com</a>.
          </div>
        </div>
      </div>
    </AuthLayout>
  );
};

export default TrialExpiredPage;
